export default "__VITE_ASSET__228007ca__"